/**
 * Reads the legacy single payment slot as a one item ledger, so the whole UI
 * only ever works with the list. Mirrors `functions/src/domain/cellPayments.ts`.
 */
export function readCellPayments(cell) {
    if (cell.payments && cell.payments.length > 0) {
        return cell.payments;
    }
    const legacy = cell.payment;
    if (!legacy?.receiptId) {
        return [];
    }
    return [{
            id: legacy.receiptId,
            kind: 'sale',
            status: 'settled',
            amount: legacy.amount,
            createdAt: legacy.paidAt,
            createdBy: legacy.paidBy,
            receiptId: legacy.receiptId,
            number: legacy.number,
            method: legacy.method,
            paidAt: legacy.paidAt,
            paidBy: legacy.paidBy,
        }];
}
/** What the lesson has actually collected, stornos and refunds included. */
export function settledNet(entries) {
    return entries
        .filter(entry => entry.status === 'settled')
        .reduce((sum, entry) => sum + entry.amount, 0);
}
/** The one amount waiting to be paid out or collected, if any. */
export function openObligation(entries) {
    return entries.find(entry => entry.status === 'due') ?? null;
}
/** Receipts the lesson can print, newest first. */
export function settledReceipts(entries) {
    return entries
        .filter(entry => entry.status === 'settled' && entry.receiptId)
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
}
export function lessonPaymentState(entries, isPrepaid) {
    const open = openObligation(entries);
    if (open) {
        return open.amount > 0 ? 'topup' : 'refund';
    }
    return settledNet(entries) > 0 || isPrepaid ? 'paid' : 'unpaid';
}
